import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MenuArbolComponent } from "./components/menu-arbol/menu-arbol.component";
import { NodoArbolComponent } from "./components/menu-arbol/nodo-arbol/nodo-arbol.component";
import { AsistenciaMenuArbolComponent } from "./asistencia-menu-arbol.component";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { BasecomponentsModule } from "../../basecomponents/basecomponents.module";
import { ConfirmarAbrirVentanaDialogComponent } from './components/menu-arbol/confirmar-abrir-ventana-dialog/confirmar-abrir-ventana-dialog.component';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, BasecomponentsModule],
  exports: [AsistenciaMenuArbolComponent],
  declarations: [
    AsistenciaMenuArbolComponent,
    MenuArbolComponent,
    NodoArbolComponent,
    ConfirmarAbrirVentanaDialogComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AsistenciaMenuArbolModule { }
